import dayjs from 'dayjs';

const ONE_DAY_TIME = 86400000;
const storage = {
    set(key, data, expire) {
        getDataProperty(data) === '[object Array]' || getDataProperty(data) === '[object Object]'
            ? sessionStorage.setItem(key, JSON.stringify(data))
            : sessionStorage.setItem(key, data);
    },

    get(key, params) {
        let data = null;
        try {
            data = JSON.parse(sessionStorage.getItem(key));
        } catch (error) {
            return sessionStorage.getItem(key);
        }
        return data;
    },
    del(item, key) {
        const getItem = storage.get(item);
        if (key) {
            delete getItem[key];
            storage.set(item, getItem);
        } else {
            sessionStorage.removeItem(item);
        }
    },

    clear() {
        sessionStorage.clear();
    },

    setLocal(key, value = '') {
        if (!key) return;
        localStorage.setItem(key, JSON.stringify(value || ''));
    },
    getLocal(key) {
        if (!key) return;
        return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null;
    },
    /**
     * 设置含有有效期功能, 只支持天数
     * @param {*} key 缓存key
     * @param {*} data 缓存数据
     * @param {*} expire 过期时间
     * @param {*} isInt 是否取结束当天的0点
     * @returns 返回 obj 或者 data
     */
    setExpireLocal(key, data, expire, isInt) {
        if (!key || (!data && data !== 0)) return;
        let obj;
        if (expire) {
            if (isNaN(expire) || expire < 1) {
                throw new Error('有效期应为一个有效数值');
            }
            let time = Date.now() + expire * ONE_DAY_TIME;
            time = isInt ? dayjs(dayjs(time).format('YYYY-MM-DD 00:00:00')).valueOf() : time;
            obj = {
                data, // 存储值
                time: Date.now(), // 存值时间戳
                expire: time // 过期时间
            };
        } else {
            obj = data;
        }
        localStorage.setItem(key, JSON.stringify(obj));
    },
    getExpireLocal(key) {
        if (!key) return;
        const data = localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null;
        if (getDataProperty(data) === '[object Object]' && data.time && data.expire) {
            const now = Date.now();
            return data.expire < now ? null : data.data;
        }
        return data;
    }
};

function getDataProperty(data) {
    return Object.prototype.toString.call(data);
}

export default storage;
